import React from 'react'
import featurePeople from "../assets/images/feature-people.png"
import featureSplit from "../assets/images/feature-split.png"
import featureFast from "../assets/images/feature-fast.svg"
import featurePassword from "../assets/images/feature-password.svg"
import featureVideo from "../assets/images/feature-video.png"
import featureSupport from "../assets/images/feature-support.png"
function FeatureService() {
    var features = [

        [featureSplit, 'Option to split likes on multiple pictures'],
        [featureVideo, 'Include video views'],
        [featurePeople, 'Real likes from real people'],
        [featurePassword, 'No password required'],
        [featureFast, 'Fast delivery (gradual or instant)'],
        [featureSupport, '24/7 Live Support']
    ]
    return (
        <div className='flex flex-col'>

            {features?.map((feature, idx) => (<div key={`service-feature-${idx}`}>
                <div className='flex flex-row'>
                    <div className='basis-1/6'></div>
                    <div idx={idx} className='flex flex-row gap-5  my-1  basis-5/6'>
                        <img className='w-4 h-4 self-center' src={feature[0]} alt='x'></img>
                        <span> {feature[1]}</span>
                    </div>
                    <div className='basis-1/6'></div>
                </div>
            </div>
            ))}
        </div>
    )
}

export default FeatureService